export default __webpack_public_path__ + "static/media/Town house.d3c3df18.jpg";